import React from 'react';
export function DecisionBox() {
  return <section className="w-full bg-gray-100 py-12 px-4" data-id="element-63">
      <div className="max-w-3xl mx-auto bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-gray-200 text-center" data-id="element-64">
        <h3 className="text-xl font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-65">
          Pregúntate esto:
        </h3>
        <p className="text-xl md:text-2xl font-bold text-gray-900 leading-relaxed mb-6" data-id="element-66">
          Si por 10€ más podés tener todo el sistema completo, incluyendo la
          guía para convertir este conocimiento en dinero real... ¿Tiene sentido
          quedarte con la mitad?
        </p>
        <p className="text-lg text-gray-600 font-medium" data-id="element-67">
          La mayoría de las personas que eligen la opción básica terminan
          deseando haber tomado la decisión completa desde el principio. No seas
          esa persona.
        </p>
      </div>

      <div className="max-w-3xl mx-auto mt-6 bg-yellow-50 border border-yellow-200 p-6 rounded-xl text-center" data-id="element-68">
        <p className="text-yellow-800 font-bold text-lg flex items-center justify-center gap-2" data-id="element-69">
          <span className="text-2xl" data-id="element-70">⏳</span> Esta oferta combinada solo está
          disponible en esta página. Una vez que cierres esta ventana, el precio
          de la Edición Profesional aumenta.
        </p>
      </div>
    </section>;
}